/**
 * Calculate current and best streaks from an array of game stats.
 * Each stat must have a `.date` string (YYYY-MM-DD).
 */
export function calculateStreaks(stats) {
  const sortedDates = [...new Set(stats.map((s) => s.date))].sort();

  let bestStreak = 0;
  let streakCounter = 0;
  let prevDate = null;

  for (const dateStr of sortedDates) {
    const current = new Date(dateStr);
    if (prevDate) {
      const diff = Math.floor((current - prevDate) / (1000 * 60 * 60 * 24));
      if (diff === 1) {
        streakCounter++;
      } else if (diff > 1) {
        streakCounter = 1;
      }
    } else {
      streakCounter = 1;
    }
    if (streakCounter > bestStreak) bestStreak = streakCounter;
    prevDate = current;
  }

  // Current streak: count consecutive days backwards from today
  let currentStreak = 0;
  let prev = new Date();
  const reversedDates = [...sortedDates].reverse();
  for (const dateStr of reversedDates) {
    const current = new Date(dateStr);
    const diff = Math.floor((prev - current) / (1000 * 60 * 60 * 24));
    if (diff > 1) break;
    currentStreak++;
    prev = current;
  }

  return { currentStreak, bestStreak };
}
